import React, { useState } from 'react'
import { Icon, Link } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleCustomer } from '../../../state/slices/currentSale/currentSaleSlice'
import { UpdateSaleCustomerModal } from '../../../modals/update-customer-modal'
import { useUnfulfilledSaleInvalidCustomer } from './useUnfulfilledSaleInvalidCustomer'

/**
 * UI component to show error message when customer contact is missing or invalid for unfulfilled sale
 */
export const UnfulfilledSaleCustomerError = () => {
  const {
    isFulfillmentPopoverOpen,
    isUnfulfilledSaleInvalidCustomer,
    isUnfulfilledSaleMissingCustomerContact,
  } = useUnfulfilledSaleInvalidCustomer()
  const saleCustomer = useAppSelector(selectSaleCustomer)
  const t = useT()
  const [showCustomerModal, setShowCustomerModal] = useState(false)
  const closeCustomerModal = () => setShowCustomerModal(false)
  const editCustomer = () => {
    if (saleCustomer) {
      setShowCustomerModal(true)
    }
  }
  return (
    <>
      {isUnfulfilledSaleMissingCustomerContact && !isFulfillmentPopoverOpen && (
        <span className="vd-pl4 vd-pr4 vd-pb2 wr-input-messages">
          <Icon icon="fa-exclamation-triangle" className="vd-mr1"></Icon>
          {t('Contact details required for unfulfilled items.', {
            _context: 'Error message',
          })}
          &nbsp;
          <Link
            href="#"
            onClick={editCustomer}
            className="vd-link vd-link--secondary"
            data-track="add-contact-details"
          >
            {t('Add details.', {
              _context: 'Error message',
            })}
          </Link>
        </span>
      )}
      {isUnfulfilledSaleInvalidCustomer && !isFulfillmentPopoverOpen && (
        <span className="vd-pl2 vd-pr2 vd-pb2 wr-input-messages">
          <Icon icon="fa-exclamation-triangle" className="vd-mr1"></Icon>
          {t('Customer required for unfulfilled items', {
            _context: 'Error message',
          })}
        </span>
      )}
      {showCustomerModal && (
        <UpdateSaleCustomerModal onClose={closeCustomerModal} />
      )}
    </>
  )
}
